import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';

export const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  font-size: 15px;
  text-align: center;
  border-radius: 0 0 0 0;
  padding: 0;
  margin: 0;
  border: 2px solid ${(props) => (props.invalid ? COLORS.red : COLORS.primary)};
  outline: none !important;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }
`;

export const StyledSelect = styled.select(StyledInput);
